import React, { useEffect } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import useMe from '../hooks/useMe';

const withJanitor = Component => args => {
  const match = useRouteMatch();
  const history = useHistory();
  const [me] = useMe();

  useEffect(() => {
    if (me && me.condominiums.findIndex(x => x.data === match.params.condominiumId) < 0) history.goBack();
  }, [me, match, history]);

  return <Component {...args} />;
};

export default withJanitor;
